(function () {
    var typed = '';
    var TRIGGER = 'whale';

    document.addEventListener('keypress', function (e) {
        typed += e.key.toLowerCase();
        if (typed.length > TRIGGER.length) typed = typed.slice(-TRIGGER.length);
        if (typed === TRIGGER) {
            typed = '';
            spawnWhale();
        }
    });

    if (decodeURIComponent(window.location.pathname).includes('/bücher/moby-dick')) {
        setTimeout(spawnWhale, 700);
    }

    // Wave SVG: seamless loop — the path repeats at 480px, animate translateX(-480px)
    // 3 repeats gives a 1440px-wide path; the SVG is 200% wide, positioned at left:-50%
    function makeWave(amp, yBase, fill, dur, delay, h) {
        var y0 = yBase, y1 = yBase - amp, y2 = yBase + amp;
        var seg = function(x0, x1, x2, x3) {
            return ' C' + x0 + ' ' + y1 + ' ' + x1 + ' ' + y2 + ' ' + x2 + ' ' + y0;
        };
        var d = 'M0 ' + y0
            + seg(60,  180,  240)
            + seg(300, 420,  480)
            + seg(540, 660,  720)
            + seg(780, 900,  960)
            + seg(1020,1140, 1200)
            + seg(1260,1380, 1440)
            + ' L1440 ' + h + ' L0 ' + h + 'Z';
        return '<svg viewBox="0 0 1440 ' + h + '" preserveAspectRatio="none"'
            + ' style="position:absolute;top:0;left:-50%;width:200%;height:' + h + 'px;'
            + 'animation:whale-wave-drift ' + dur + ' linear ' + delay + ' infinite;">'
            + '<path d="' + d + '" fill="' + fill + '"/>'
            + '</svg>';
    }

    function makeWhaleSilhouette() {
        // Minimal sperm whale — blunt head facing left, no fussy details
        return '<svg viewBox="0 0 660 120" width="660" height="120"'
            + ' style="position:absolute;bottom:14%;left:50%;transform:translateX(-50%);'
            + 'opacity:0;animation:whale-rise 1.5s ease 1.4s forwards;">'
            + '<path d="'
            +   'M 20 30 L 10 60 L 20 90 '
            +   'C 72 106 145 108 205 100 '
            +   'C 360 114 498 106 608 88 '
            +   'C 638 82 652 74 657 70 '
            +   'C 652 66 638 58 608 52 '
            +   'C 498 34 360 26 205 40 '
            +   'C 145 32 72 32 20 30 Z'
            + '" fill="rgba(4,18,55,1)"/>'
            // dorsal hump
            + '<path d="M 410 52 Q 432 28 454 50 Z" fill="rgba(4,18,55,1)"/>'
            // upper fluke
            + '<path d="M 657 70 Q 688 50 703 30 Q 699 58 707 68 L 657 70 Z" fill="rgba(4,18,55,1)"/>'
            // lower fluke
            + '<path d="M 657 70 Q 688 90 703 110 Q 699 82 707 72 L 657 70 Z" fill="rgba(4,18,55,1)"/>'
            + '</svg>';
    }

    function spawnWhale() {
        if (document.querySelector('.whale-overlay')) return;

        var overlay = document.createElement('div');
        overlay.className = 'whale-overlay';

        var quote = document.createElement('div');
        quote.className = 'whale-quote';
        quote.textContent = '„Call me Ishmael."';
        overlay.appendChild(quote);

        // Ocean section — contains waves and whale
        var ocean = document.createElement('div');
        ocean.className = 'whale-ocean';

        ocean.innerHTML = makeWhaleSilhouette()
            // 4 wave layers: back (lighter, smaller) → front (darker, larger)
            + makeWave(8,  38, 'rgba(28, 88, 185, 0.50)', '20s', '0s',   52)
            + makeWave(12, 44, 'rgba(18, 65, 150, 0.68)', '14s', '-5s',  60)
            + makeWave(16, 50, 'rgba(10, 45, 115, 0.84)', '9s',  '-3s',  70)
            + makeWave(20, 56, 'rgba(4,  28,  75, 0.97)', '6s',  '-1.5s',80);

        overlay.appendChild(ocean);

        var closeBtn = document.createElement('button');
        closeBtn.className = 'ee-close';
        closeBtn.textContent = '×';
        closeBtn.addEventListener('click', function () {
            overlay.classList.add('whale-overlay--fade');
            setTimeout(function () { overlay.remove(); }, 1400);
        });
        overlay.appendChild(closeBtn);
        document.body.appendChild(overlay);

        setTimeout(function () {
            overlay.classList.add('whale-overlay--fade');
            setTimeout(function () { overlay.remove(); }, 1400);
        }, 5000);
    }
})();
